// Adapted from our own Immersive Worlds EventBus.
// Source blob: c882058b5f21992582728411ff0b610be0c6c741

export const EVENTS = Object.freeze({
  WORLD_READY: 'world:ready',
  WORLD_STATE_CHANGED: 'world:state-changed',
  SPACE_ENTERED: 'space:entered',
  SPACE_LEFT: 'space:left',
  ENTITY_FOCUSED: 'entity:focused',
  ENTITY_FOCUS_LEFT: 'entity:focus-left',
  PROPERTY_STATE_CHANGED: 'property:state-changed',
  PROPERTY_SAVED: 'property:saved',
  PROPERTY_REJECTED: 'property:rejected',
  PROPERTY_COMPARE_CHANGED: 'property:compare-changed',
  VISIT_REQUESTED: 'visit:requested',
  BUYER_PROFILE_CHANGED: 'buyer-profile:changed',
  FILTERS_CHANGED: 'filters:changed',
  MODE_CHANGED: 'mode:changed',
  CAMERA_AUTHORITY_CHANGED: 'camera:authority-changed'
});

const KNOWN = new Set(Object.values(EVENTS));

export class EventBus {
  constructor({ recordHistory = false, historyLimit = 500 } = {}) {
    this._handlers = new Map();
    this._recordHistory = recordHistory;
    this._historyLimit = historyLimit;
    this.history = [];
  }

  on(name, handler) {
    assertKnown(name);
    let set = this._handlers.get(name);
    if (!set) {
      set = new Set();
      this._handlers.set(name, set);
    }
    set.add(handler);
    return () => set.delete(handler);
  }

  emit(name, payload = {}) {
    assertKnown(name);
    if (this._recordHistory) {
      this.history.push({ name, payload, t: this.history.length });
      if (this.history.length > this._historyLimit) this.history.shift();
    }
    const set = this._handlers.get(name);
    if (!set) return;
    for (const handler of [...set]) handler(payload);
  }
}

function assertKnown(name) {
  if (!KNOWN.has(name)) throw new Error(`[WCB] Unknown semantic event: ${name}`);
}
